import service from '@api/config'

// 朋友圈列表（全部）
export const listAll = (data) => {
  return service.request({
    url: `/friendCircle/list/all`,
    method: 'post',
    data: data
  })
}

// 朋友圈列表（仅朋友）
export const listFriend = (data) => {
  return service.request({
    url: `/friendCircle/list/friend`,
    method: 'post',
    data: data
  })
}

// 朋友圈列表（同城）
export const listCity = (data, cityId) => {
  return service.request({
    url: `/friendCircle/list/city?city=` + cityId,
    method: 'post',
    data: data
  })
}

// 我的朋友圈列表
export const listMyFriend = (data) => {
  return service.request({
    url: `/friendCircle/my/list`,
    method: 'post',
    data: data
  })
}

// 互动通知
export const interact = (data) => {
  return service.request({
    url: `/friendCircle/interact`,
    method: 'post',
    data: data
  })
}

// 互动消息列表
export const listInteract = (data) => {
  return service.request({
    url: `/friendCircle/interact/list`,
    method: 'post',
    data: data
  })
}

// 互动消息已读/清空
export const interactChangeStatus = (id) => {
  return service.request({
    url: `/friendCircle/interact/changeStatus?interactId=` + id,
    method: 'post'
  })
}

// 获取朋友圈详情
export const detail = (data) => {
  return service.request({
    url: `/friendCircle/detail`,
    method: 'post',
    data: data
  })
}

// 朋友圈点赞
export const like = (id) => {
  return service.request({
    url: `/friendCircle/likes?friendCircleId=` + id,
    method: 'post'
  })
}

// 朋友圈取消点赞
export const unLike = (id) => {
  return service.request({
    url: `/friendCircle/delete/likes?friendCircleId=` + id,
    method: 'post'
  })
}

// 朋友圈评论
export const comment = (data) => {
  return service.request({
    url: `/friendCircle/comment`,
    method: 'post',
    data: data
  })
}

// 朋友圈删除评论
export const deleteComment = (id) => {
  return service.request({
    url: `/friendCircle/delete/comment?friendCommentId=` + id,
    method: 'post'
  })
}

// 朋友圈删除
export const deleteFriendCircle = (id) => {
  return service.request({
    url: `/friendCircle/delete?friendCircleId=` + id,
    method: 'post'
  })
}

// 朋友圈新增
export const pubFriendCircle = (data) => {
  return service.request({
    url: `/friendCircle/publish`,
    method: 'post',
    data: data
  })
}

// 朋友圈获取头像
export const getHeadImage = (data) => {
  return service.request({
    url: `/user/getHeadImage`,
    method: 'post',
    data: data
  })
}

// 重新发布朋友圈
export const republish = (data) => {
  return service.request({
    url: `/friendCircle/republish`,
    method: 'post',
    data: data
  })
}
